import { createContext, ReactNode, useContext } from 'react'
import EnhancedConfirmDialog from './EnhancedConfirmDialog'
import { useConfirmDialog } from './useConfirmDialog'

interface ConfirmDialogContextType {
    confirm: (options: Parameters<ReturnType<typeof useConfirmDialog>['confirm']>[0]) => Promise<boolean>
}

const ConfirmDialogContext = createContext<ConfirmDialogContextType | null>(null)

export const useConfirmDialogContext = () => {
    const context = useContext(ConfirmDialogContext)
    if (!context) {
        throw new Error('useConfirmDialogContext must be used within a ConfirmDialogProvider')
    }
    return context
}

interface ConfirmDialogProviderProps {
    children: ReactNode
}

export const ConfirmDialogProvider = ({ children }: ConfirmDialogProviderProps) => {
    const { confirm, dialogState, handleConfirm, handleCancel, handleClose } = useConfirmDialog()

    return (
        <ConfirmDialogContext.Provider value={{ confirm }}>
            {children}
            <EnhancedConfirmDialog
                dialogState={dialogState}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
                onClose={handleClose}
            />
        </ConfirmDialogContext.Provider>
    )
} 